<h3 i18n="@@titleGroups">Groups</h3>

@if (groupsLoaded()) {
	@if (groups().length > 0) {
		<ul>
			@for (group of groups(); track group.groupName) {
				<li>
					{{ group.groupName }}
					@if (group.description) {
						<em>— {{ group.description }}</em>
					}
				</li>
			}
		</ul>
	} @else {
		<p i18n="@@NoGroupsFound">No groups found.</p>
	}
} @else {
	<mat-spinner />
}
